module.exports = __webpack_public_path__ + "img/startupindia.ee7dc4c8.png";